var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var File = function (props) {
    var id = props.id, isValid = props.isValid, accept = props.accept, disabled = props.disabled, required = props.required, value = props.value, onChange = props.onChange;
    var isValidFile = function (isValid, accept, value) {
        var types = accept != null ? accept.split(',') : [];
        return (isValid &&
            (value == null ||
                (accept &&
                    types !== [] &&
                    types.some(function (t) { return value.trim().endsWith(t.trim()); }))));
    };
    return (React.createElement("div", { id: id + "-container", className: "custom-file b-form-file" },
        React.createElement("input", __assign({ accept: accept }, (required && !isValidFile(isValid, accept, value)
            ? { 'aria-required': true, required: true }
            : {}), { className: "custom-file-input", disabled: disabled, id: id, type: "file", onChange: onChange })),
        React.createElement("label", { className: "custom-file-label", htmlFor: id, "data-browse": "Browse" }, value != null && value !== '' ? value : 'No file chosen')));
};
export default File;
